var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClanTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9491 38.9375L35.2075 8.9375C32.0042 3.52083 23.9958 3.52083 20.7925 8.9375L3.05088 38.9375C-0.15247 44.3542 3.85171 51.125 10.2584 51.125H45.7416C52.1483 51.125 56.1525 44.3542 52.9491 38.9375ZM36.8708 8C32.9282 1.33334 23.0718 1.33333 19.1292 8L1.3876 38C-2.55498 44.6667 2.37324 53 10.2584 53H45.7416C53.6268 53 58.555 44.6667 54.6124 38L36.8708 8Z",
    fill: "#1D1D1F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.2939,
    cy: 17.3711,
    r: 5.5,
    stroke: "#1D1D1F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7988,
    cy: 30.4742,
    r: 4.5,
    stroke: "#1D1D1F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0874,
    cy: 42.2577,
    r: 3.5,
    stroke: "#1D1D1F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.1909,
    cy: 42.2577,
    r: 3.5,
    stroke: "#1D1D1F"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.1079,
    cy: 30.4742,
    r: 4.5,
    stroke: "#1D1D1F"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.397,
    cy: 42.2577,
    r: 3.5,
    stroke: "#1D1D1F"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 42.2577,
    r: 3.5,
    stroke: "#1D1D1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClanTriangle);
export default __webpack_public_path__ + "static/media/clan-triangle.17a13e0e082f4fceec51889dc5b4090b.svg";
export { ForwardRef as ReactComponent };